import { Typography } from '@tunasong/ui-lib'
import { useEffect, useRef, type FC } from 'react'
import { ToolsMenuItems } from './tools-menu-items.js'

/**
 * The phone's Tools tab, as a page at `/app/tools` (docs/ux/2026-11-02-phone-tools-tab.md, option A). It was a
 * full-screen dialog over the tab bar: the other tabs were out of reach, Tools was never current, and ✕ was the only
 * way out. As a page the bar stays, Tools is current, and Back works through history.
 *
 * The same list as the sidebar. The Tuner and Mixer still open full screen on a phone (GH #2999); closing them leaves
 * the reader here, so nothing is passed that would navigate away.
 */
export const ToolsPage: FC = () => {
  const headingRef = useRef<HTMLHeadingElement>(null)

  /** Focus moves to the page heading on arrival, as on the other pages */
  useEffect(() => {
    headingRef.current?.focus()
  }, [])

  return (
    <>
      <Typography variant="h1" align="center" color="text.secondary" ref={headingRef} tabIndex={-1}>
        Tools
      </Typography>
      <ToolsMenuItems variant="subtitle1" />
    </>
  )
}

export default ToolsPage
